shadow$provide[299] = function(require,module,exports) {
var require$_DOT__SLASH_move_DOT_js = require("./move.js");
var require$_DOT__SLASH_play_DOT_js = require("./play.js");
var require$_DOT__SLASH_present_DOT_js = require("./present.js");
var require$_DOT__SLASH_reveal_DOT_js = require("./reveal.js");
var require$_DOT__SLASH_slide_DOT_js = require("./slide.js");
var require$_DOT__SLASH_step_DOT_js = require("./step.js");
require.exportCopy(module, require$_DOT__SLASH_move_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_play_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_present_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_reveal_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_slide_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_step_DOT_js);

};